module.exports = __webpack_public_path__ + "static/Kaizen_CorredorSul_Acesso-b5f101898194a42b5794ab850aa87686.png";